import React, { useEffect, useMemo, useState } from "react";
import * as S from "./ContentCard.style";
import FlorenzButton from "../../../../florenzComponents/florenzButton";
import FlorenzSearchInput from "../../../../florenzComponents/florenceSearchInput";
import * as P from "../../../../../utils/pipes";
import { useTranslation } from "react-i18next";


function ContentCard ({
  setInputText,
  setContentSelected,
  selectContent,
  item
}) {  

  const {t, i18n: { language }} = useTranslation("global");

  const normalizedTags = useMemo(() => {
    const uniqueCommentsMap = new Map();

    item?.mediaCards.forEach(card => {
      card.mediaCardToMediaTags.forEach(tag => {
        const comment = tag.enMediaTag.comment;
        const key = JSON.stringify(comment);
        if (!uniqueCommentsMap.has(key)) {
          uniqueCommentsMap.set(key, comment);
        }
      });
    });

    return Array.from(uniqueCommentsMap.values()).map(item => {
      return P.dataTranslation(item, language);
    })

  }, [item]);

  return (
    <S.ContentCard>
      <div className="content-card"
        onClick={() => selectContent(item)}
      >
        <div className="content-card__img">
          <img src={
            item?.imageUrl
              ? item.imageUrl
              : "https://blocks.astratic.com/img/general-img-portrait.png"
            // "https://img.freepik.com/foto-gratis/dia-mundial-cancer-personas-abrazadas_23-2151064696.jpg?t=st=1752243545~exp=1752247145~hmac=14e40130810e9b6cd21c4d089c29891b89d1d6e479ca94ed1cf10135dc127c16&w=826"
          } alt="content-img" className="content-img" />
        </div>
        <div className="content-card__principal">
          <a className="content-title">{P.dataTranslation(item?.name, language)}</a>
          {/* <div className="content-seasons">
            {`${8} ${"Temporadas"}`}
          </div> */}
        </div>
        <div className="content-card__separation"></div>
        <div className="content-card__categories">
          {
            normalizedTags.length > 0 
              ? normalizedTags.join(', ')
              : t("globally.noCategories")
          }
        </div>
        <div className="content-card__separation"></div>
        <div className="content-card__description">
          {P.dataTranslation(item?.description, language)}
        </div>
        <div className="content-card__separation"></div>
        <div className="content-card__options">
          <div className="access-programs">
            <div className="access-programs__text">{`${item.processToMediaGroups.length}  ${t("globally.programs")}`}</div>
            <div className="access-programs__text">{t("globally.haveAccess")}</div>
          </div>
          <div className="button-container">
            <FlorenzButton
              typeStyle={"secondaryWhite"}
              size="s"
              icon="zaia-icono-visibility"
              text={t("globally.viewContent")}
              widthComplete={true}
            />
          </div>
        </div>
      </div>
    </S.ContentCard>
  )

}

export default ContentCard;
